import { config } from 'dotenv';

config({
    path: `../.env.${process.env.NODE_ENV}`
});

export const ClientId = process.env.REACT_APP_CLIENT_ID;
export const IdentityUrl = process.env.REACT_APP_IDENTITY_URL;
export const RedirectPath = process.env.REACT_APP_REDIRECT_PATH;